import { genObjectKey } from '@debbie/common/dist/util/index.js';
import q from '../query.js';
import { workerHeavy } from './worker-client.js';
export const useShareVouchers = (baseVoucher, documents, economyPolicy, case_, billingModel, fixedDistributions, conditions, caseVouchers) => q.query(genObjectKey([
    baseVoucher,
    documents,
    economyPolicy,
    case_,
    billingModel,
    fixedDistributions.map((d) => d.id),
    caseVouchers,
    conditions,
]), () => workerHeavy.getShareVouchers(baseVoucher, documents, economyPolicy, case_, billingModel, fixedDistributions, conditions, caseVouchers), []);
export const useReadyToSubmit = (validationData, config) => q.query(genObjectKey([validationData, config]), () => workerHeavy.readyToSubmit({
    interactions: validationData.interactions,
    updates: validationData.updates,
    caseVouchers: validationData.caseVouchers,
    documents: validationData.documents,
    customer: validationData.customer,
    creditor: validationData.creditor,
    templates: validationData.templates,
    tenant: validationData.tenant,
    case: validationData.case,
    fixedDistributions: validationData.fixedDistributions,
    conditions: validationData.conditions,
}, config), [], {
    enabled: validationData.interactions != null &&
        validationData.updates != null &&
        validationData.caseVouchers != null &&
        validationData.documents != null &&
        validationData.customer != null &&
        validationData.creditor != null &&
        validationData.templates != null &&
        validationData.tenant != null &&
        validationData.fixedDistributions != null &&
        validationData.conditions != null,
});
export const useGetBalance = (caseVouchers, documents, economyPolicy, fixedDistributions, plan, conditions) => q.query(genObjectKey([
    caseVouchers,
    documents,
    economyPolicy,
    plan,
    fixedDistributions.map((d) => d.id),
    conditions,
]), () => workerHeavy.balanceAfterPlan(caseVouchers, documents, economyPolicy, fixedDistributions, plan, conditions), []);
export const useInterestCalulation = (caseVouchers, documents, economyPolicy, fixedDistributions, conditions, untilISOString, options) => q.query(genObjectKey([
    caseVouchers,
    documents,
    economyPolicy,
    untilISOString,
    fixedDistributions?.map((d) => d.id),
    conditions,
    options,
]), () => workerHeavy.interestCalculate(caseVouchers, documents, economyPolicy, fixedDistributions, untilISOString, { ...options, ...conditions }), [], {
    enabled: caseVouchers != null &&
        documents != null &&
        economyPolicy != null &&
        untilISOString != null &&
        fixedDistributions != null &&
        conditions != null,
});
export const useGeneratePaymentPlan = ({ tenant, creditor, economyEngine, caseVouchers, documents, fixedDistributions, config, conditions, }) => q.query(`payment-plan:${genObjectKey([
    tenant,
    creditor,
    economyEngine,
    caseVouchers,
    documents,
    fixedDistributions,
    config,
    conditions,
])}`, async () => workerHeavy.generatePaymentPlan(tenant, creditor, economyEngine, caseVouchers, documents, fixedDistributions, config, conditions, {}), [], {
    enabled: tenant != null &&
        creditor != null &&
        economyEngine !== null &&
        caseVouchers != null &&
        documents != null &&
        fixedDistributions != null &&
        config != null &&
        conditions != null,
    expireTime: 30_000,
});
//# sourceMappingURL=index.js.map